import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { CompanyGroupForPermissionListItem, ICompanyGroupForPermissionListItem } from "./companyGroupForPermissionListItem";

export interface ICompanyGroupForPermissionListItems extends IListItems<ICompanyGroupForPermissionListItem> {}

export class CompanyGroupForPermissionListItems extends ListItems<CompanyGroupForPermissionListItem> implements ICompanyGroupForPermissionListItems {
    constructor();
    constructor(obj: ICompanyGroupForPermissionListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, CompanyGroupForPermissionListItem);
    }
}